import { Model } from '@vuex-orm/core';
import TechnologistConfig from '@/models/interfaces/Technologist';
import TechnologistAPI from '@/api/TechnologistAPI';

export default class Technologist extends Model {
    public static entity = 'technologist';

    public static fields() {
        return {
            id: this.attr(null),
            name: this.string(''),
            isActive: this.boolean(true),
        };
    }

    public static async getAll() {
        let technologists;
        try {
            technologists = await TechnologistAPI.getAll();
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: technologists.data,
        });
        return Promise.resolve();
    }

    public static async getById(id: string) {
        let technologist;
        try {
            technologist = await TechnologistAPI.getById(id);
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: technologist.data,
        });
        return Promise.resolve(technologist);
    }

    public static async updateExisting(id: string, info: TechnologistConfig) {
        let technologist;
        try {
            technologist = await TechnologistAPI.update(id, info);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologist);
    }

    public static async createNew(info: TechnologistConfig) {
        let technologist;
        try {
            technologist = await TechnologistAPI.create(info);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(technologist);
    }

    public static async deleteExisting(id: string) {
        try {
            await TechnologistAPI.delete(id);
        } catch (e) {
            return Promise.reject(e);
        }
        await Technologist.delete(id);
        return Promise.resolve();
    }

    public id!: string;
    public name!: string;
    public isActive!: boolean;
}